import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import Numeral from 'numeral';

import Button from 'components/Button';
import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';

import { URLS } from 'config';

import TransmissionModal from './components/TransmissionModal';


import './styles.scss';
// eslint-disable-next-line
import 'antd/lib/icon/style/css';

import bagage from './images/bagage.svg';
import doors from './images/doors.svg';
import autoTransmission from './images/auto-transmission.svg';
import manualTransmission from './images/manual-transmission.svg';
import containerActions from './actions';
// import passengers from './images/passengers.svg';

// eslint-disable-next-line
const ArrowButton = ({ type, onClick, className }) => (
  <button className={className} onClick={onClick}>
    <i className={`icon-arrow-${type}`} />
  </button>
);

ArrowButton.defaultProps = {
  type: '',
  onClick: () => {}
};

ArrowButton.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func,
  // eslint-disable-next-line
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};


class CarPage extends React.Component {
  state = {
    modalOpened: true,
    transmissionMoadl: false,
    selectedTransmission: 'manual'
  }
  componentWillMount() {
    if (this.props.match.params.id) {
      this.props.getCar(this.props.match.params.id);
      this.props.getCarById(this.props.match.params.id);
    } else {
      push(URLS.APPROVED);
    }
  }

  settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <ArrowButton type="right" />,
    prevArrow: <ArrowButton type="left" />
  }


  selectHandl = () => {
    this.props.addCar(() => {
      this.props.history.push(URLS.DELIVERY);
    }, this.props.car.id);
  }

  backHandl = () => {
    this.props.history.goBack();
  }

  toggleTransmisionModal = () => {
    this.setState(prevState => ({
      transmissionMoadl: !prevState.transmissionMoadl
    }));
  }

  selectTransmissionHandl = selectedTransmission => () => {
    this.setState({ selectedTransmission });
  }

  render() {
    return (
      <Modal isOpen={this.state.modalOpened}>
        <div className="page-car">
          <ModalHeader backHandl={this.backHandl} >
            {this.props.car.name || ''}
          </ModalHeader>

          <div className="car-slider">
            <Slider
              {...this.settings}
              arrows={this.props.car.images && this.props.car.images.length}
            >
              {
                this.props.car.images ? this.props.car.images.map((el) => {
                  const splitted = el.split('?');
                  return splitted ? (
                    <div className="slider-item" key={el}>
                      <div className="slider-image" style={{ backgroundImage: `url(${splitted[0]})` }} />
                    </div>
                  ) : null;
                }) : null
              }
            </Slider>
          </div>

          <div className="car-info">
            {
              this.props.car.seating ?
                <div className="info-item">
                  <i className="material-icons icon">person</i>
                  {this.props.car.seating}
                </div>
              : null
            }
            {
              this.props.car.doors ?
                <div className="info-item">
                  <i className="info-image" style={{ backgroundImage: `url(${doors})` }} />
                  {this.props.car.doors}
                </div>
              : null
            }
            {
              this.props.car.bagage ?
                <div className="info-item">
                  <i className="info-image" style={{ backgroundImage: `url(${bagage})` }} />
                  {this.props.car.bagage}
                </div>
              : null
            }
          </div>

          <div className="car-detail">
            {
            this.props.car.transmission ?
              <button className="detail-item">
                <i
                  className="item-img"
                  style={{
                    backgroundImage:
                    // `url(${this.state.selectedTransmission === 'manual'
                    // onClick={this.toggleTransmisionModal}
                    `url(${this.props.car.transmission.toLowerCase() === 'manual'
                    ? manualTransmission : autoTransmission})`
                  }}
                />
                <span className="item-text">
                  {/* { this.state.selectedTransmission === 'manual'
                    ? 'Manual' : 'Automatic' } Transmission */}
                  { this.props.car.transmission.toLowerCase() === 'manual' ? 'Manual' : 'Automatic' } Transmission
                </span>
                {/* <i className="icon-arrow-right" /> */}
              </button>
          : null
          }
            {
            this.props.car.color && this.props.car.color.exterior ?
              <button className="detail-item">
                <i className="item-img" style={{ backgroundColor: this.props.car.color.exterior, border: '1px solid #e2e2e2' }} />
                <span className="item-text">
                  {this.props.car.color.exterior}
                </span>
                {/* <i className="icon-arrow-right" /> */}
              </button>
            : null
          }

          </div>

          <div className="car-price">
            <p className="price-info">
              Includes Tax of 13% HST
            </p>
            <div className="price-wrapper">
              <p className="price-value">
              ${Numeral(this.props.car.price).format('0.00') || 0}
              </p>
              <p className="price-info">
              per month
              </p>
            </div>
          </div>

          <Button
            onClick={this.selectHandl}
            disabled={false}
          >
			Select this car
          </Button>

          <TransmissionModal
            isOpen={this.state.transmissionMoadl}
            selectTransmissionHandl={this.selectTransmissionHandl}
            toggleTransmisionModal={this.toggleTransmisionModal}
            selectedTransmission={this.state.selectedTransmission}
          />
        </div>
      </Modal>
    );
  }
}

CarPage.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  match: PropTypes.object.isRequired,
  getCar: PropTypes.func.isRequired,
  addCar: PropTypes.func.isRequired,
  getCarById: PropTypes.func.isRequired,
  // eslint-disable-next-line
  car: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  car: state.car.car
});

export default connect(mapStateToProps, containerActions)(CarPage);



// WEBPACK FOOTER //
// ./src/pages/CarPage/index.js